import { IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';

abstract class PrizeWinnerData {
    public totalWinners: number;
    public jackpot: boolean;
    public winners: PrizeWinner[] = [];

    protected abstract getStages(node: IXmlNode): DefaultStageElement[];

    constructor(node: IXmlNode) {
        this.winners = this.getWinners(node);
    }

    protected getWinners(node: IXmlNode): PrizeWinner[] {
        const winnerNodes = node.childNodes.winner;
        const winnerList: PrizeWinner[] = [];
        const stages = this.getStages(node);

        this.jackpot = safeCast(node.attributes.jackpot, false);
        winnerNodes.forEach((winnerNode) => {
            const prizeWinner = new PrizeWinner(winnerNode);
            const stage = this.findStage(stages, prizeWinner.stage);
            prizeWinner.prizeName = stage ? stage.name : null;
            winnerList.push(prizeWinner);
        });
        return winnerList;
    }

    private findStage(stages: DefaultStageElement[], stage: number): DefaultStageElement {
      return stages.find((obj) => obj.stage === stage);
    }
}

class PrizeWinner {
    public username: string;
    public prizeInPence: number;
    public stage: number;
    public level?: number;
    public prizeName?: string;
    public jackpot: boolean;

    constructor(messageNode: IXmlNode, stagePrizeName?: string) {
        this.username = messageNode.attributes.user || messageNode.attributes.User;
        this.prizeInPence = safeCast(messageNode.attributes.prize, 0);
        this.stage = safeCast(messageNode.attributes.stage, 0);
        this.level = safeCast(messageNode.attributes.level || messageNode.attributes.prizelevel, 0);
        this.prizeName = stagePrizeName;
        this.jackpot = safeCast(messageNode.attributes.jackpot, false);
    }
}

export { PrizeWinnerData, PrizeWinner };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/prize-winner/prize-winner-data.ts